import { CoordinateKind } from 'src/lib/graphqlTypes/types';

export const friendlyCoordinateKind = new Map<CoordinateKind, string>([
  [CoordinateKind.ENUM_VALUE, 'enum value'],
  [CoordinateKind.INPUT_OBJECT_FIELD, 'input field'],
  [CoordinateKind.OBJECT_FIELD, 'field'],
]);
